import { FC } from 'react';

import { Box, Flex, Icon } from '@chakra-ui/react';
import ArrowRight from 'images/icons/arrow-up-right-grey.svg';

import { Button } from '@/components/atoms';
import { GeneralPath } from '@/utils/models';

export const CaseStudyActionButton: FC<{ buttonLabel?: string }> = ({ buttonLabel }) => {
  return (
    <Flex
      flexDir="column"
      alignItems="center"
      justifyContent={{
        base: 'end',
        md: 'initial',
      }}
      zIndex={101}
      position="relative"
      bottom={0}
      maxW={{
        base: 'unset',
      }}
      w={{
        base: '100%',
      }}
      pt="100px"
    >
      <Box position="relative">
        <Button
          label={buttonLabel || ''}
          rightIcon={
            <Flex bg="violet.500" h="36px" w="36px" display="flex" alignItems="center" justifyContent="center">
              <Icon
                as={ArrowRight}
                w="20px"
                h="20px"
                className="arrow-icon"
                sx={{ path: { fill: 'white' } }}
                transition="transform 0.3s ease"
                alignSelf="center"
              />
            </Flex>
          }
          bg="none"
          color="white"
          mt={5}
          maxW="360px"
          size="lg"
          borderRadius="44px"
          url={GeneralPath.CASE_STUDIES}
          _hover={{
            color: 'violet.500',
            '.arrow-icon': {
              transform: 'rotate(0deg)',
            },
            bg: 'none',
          }}
        />
      </Box>
    </Flex>
  );
};
